export default __webpack_public_path__ + "static/media/dartboard2.8d7db7d9.png";